﻿import { epic$ } from '@redux/store';
import {
  postBuildablePlanBrochureEpic,
  postCommunityBrochureEpic,
  postPlanBrochureEpic,
  postSpecBrochureEpic,
  postRecommendedBrochureEpic,
  getRecommendedBrochureEpicPaid,
  getRecommendedBrochureEpicBasic,
  postSpecBrochureBasicEpic,
  postPlanBrochureBasicEpic,
  postCommunityBrochureBasicEpic,
  postBasicLisitingBrochureBasicEpic
} from './redux/epics';
import LeadFormType from './enums/leadFormType';

epic$.next(postBuildablePlanBrochureEpic);
epic$.next(postCommunityBrochureEpic);
epic$.next(postPlanBrochureEpic);
epic$.next(postSpecBrochureEpic);
epic$.next(postRecommendedBrochureEpic);
epic$.next(getRecommendedBrochureEpicPaid);
epic$.next(getRecommendedBrochureEpicBasic);
epic$.next(postSpecBrochureBasicEpic);
epic$.next(postPlanBrochureBasicEpic);
epic$.next(postCommunityBrochureBasicEpic);
epic$.next(postBasicLisitingBrochureBasicEpic);

require('./components/wrapper');

export default LeadFormType;